<template>
  <el-scrollbar
    class="login-overlay v-login-overlay"
    :inverse="inverse"
  >
    <div class="login-overlay__logo-container">
      <img
        class="login-overlay__logo"
        :class="`login-overlay--${themeName}`"
        :src="themeData.loginLogo"
        :alt="themeData.productName"
      />
    </div>
    <slot />
  </el-scrollbar>
</template>
<script>
  import { mapState } from 'pinia';
  import useThemeStore from '@/common/store/pinia/theme';

  export default {
    name: 'LoginOverlay',
    props: {
      inverse: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      ...mapState(useThemeStore, ['themeName', 'themeData']),
    }
  };
</script>
<style lang="scss" scoped>
  .login-overlay {
    width: 100vw;
    height: 100vh;
    background: $av-nav-primary;

    &__logo {
      position: absolute;
      bottom: 16px;
    }

    &__logo-container {
      position: relative;
      display: flex;
      justify-content: center;
      height: 214px;
    }
  }
</style>
